import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Calendar, Clock, Users, Loader2, Timer } from "lucide-react";

export default function GameListSidebar({ games, selectedGame, setSelectedGame, refreshSelectedGame, isLoading, t }) {
  return (
    <Card className="bg-card/50 border-border/50">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Calendar className="h-5 w-5 text-primary" />
          Jogos ({games.length})
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="flex justify-center py-8">
            <Loader2 className="h-8 w-8 animate-spin" />
          </div>
        ) : games.length === 0 ? (
          <div className="text-center py-8 text-muted-foreground">
            <Calendar className="h-12 w-12 mx-auto mb-3 opacity-50" />
            <p>Nenhuma inscricao aberta</p>
            <p className="text-sm">Clique em &ldquo;Abrir Inscricoes&rdquo;</p>
          </div>
        ) : (
          <div className="space-y-3">
            {games.map((game) => {
              const regCount = game.registered_players?.length || 0;
              const waitCount = game.waitlist?.length || 0;
              return (
                <div
                  key={game.id}
                  onClick={() => {
                    setSelectedGame(game);
                    refreshSelectedGame(game.id);
                  }}
                  className={`p-3 rounded-lg cursor-pointer transition-colors ${
                    selectedGame?.id === game.id
                      ? "bg-primary/20 border border-primary/50"
                      : "bg-secondary/30 hover:bg-secondary/50"
                  }`}
                  data-testid={`game-card-${game.id}`}
                >
                  <div className="flex items-start justify-between">
                    <div>
                      <h3 className="font-medium">{game.title}</h3>
                      <p className="text-sm text-muted-foreground">
                        {new Date(game.date + "T00:00:00").toLocaleDateString("pt-BR")} as {game.time}
                      </p>
                    </div>
                    <Badge
                      variant={game.is_open ? "default" : game.scheduled_open ? "outline" : "secondary"}
                      className={game.scheduled_open && !game.is_open ? "border-primary text-primary" : ""}
                    >
                      {game.is_open ? t("gameRegistrations.open") : game.scheduled_open ? "Agendado" : t("gameRegistrations.closed")}
                    </Badge>
                  </div>
                  <div className="flex items-center gap-2 mt-2">
                    <Users className="h-3 w-3 text-muted-foreground" />
                    <span className="text-sm">
                      {regCount}/{game.max_players}
                    </span>
                    {waitCount > 0 && (
                      <Badge variant="outline" className="text-xs bg-amber-500/10 text-amber-400 border-amber-500/30">
                        +{waitCount} espera
                      </Badge>
                    )}
                  </div>
                  {game.guest_deadline && (
                    <div className="flex items-center gap-1 mt-1">
                      <Timer className="h-3 w-3 text-muted-foreground" />
                      <span className="text-xs text-muted-foreground">
                        Prazo: {new Date(game.guest_deadline).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}
                      </span>
                    </div>
                  )}
                  {game.scheduled_open && !game.is_open && (
                    <div className="flex items-center gap-1 mt-1">
                      <Clock className="h-3 w-3 text-primary" />
                      <span className="text-xs text-primary font-medium">
                        Abre: {new Date(game.scheduled_open).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}
                      </span>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
